import {
    CentosIcon,
    DebianIcon,
    FedoraIcon,
    FreeBsdIcon,
    LinuxIcon,
    MacIcon,
    RedhatIcon,
    SuseIcon,
    UbuntuIcon,
    WindowsIcon
} from '../icons'

export const osIcons = {
    UbuntuIcon,
    DebianIcon,
    CentosIcon,
    RedhatIcon,
    LinuxIcon,
    SuseIcon,
    FreeBsdIcon,
    FedoraIcon,
    MacIcon,
    WindowsIcon
}
